import axios from "axios";

// Live Render Backend
const API = "https://website-dorado9.onrender.com/api";

export const api = axios.create({
  baseURL: API,
});

const TOKEN_KEY = "dorado9_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);

export const setToken = (token) => {
  localStorage.setItem(TOKEN_KEY, token);
};

export const clearToken = () => {
  localStorage.removeItem(TOKEN_KEY);
};

// Attach admin bearer token to every request when present
api.interceptors.request.use((config) => {
  const token = getToken();

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export const wordpressApi = axios.create({

  baseURL: "https://dorado9-com-897128.hostingersite.com/wp-api.php",

});